import { Home, BarChart3, Inbox, MoreHorizontal } from "lucide-react";

const TABS = [
    { id: "home", label: "Home", icon: Home },
    { id: "analytics", label: "Analytics", icon: BarChart3 },
    { id: "inbox", label: "Inbox", icon: Inbox },
    { id: "manage", label: "Manage", icon: MoreHorizontal },
];

export default function MobileBottomNav({ active, onChange, inboxCount = 0 }) {
    return (
        <nav
            className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-4 bg-white border-t border-slate-200 shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.15)]"
            data-testid="mobile-admin-bottom-nav"
            style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
        >
            {TABS.map((t) => {
                const isActive = active === t.id;
                return (
                    <button
                        key={t.id}
                        onClick={() => onChange(t.id)}
                        data-testid={`mobile-tab-${t.id}`}
                        className={`relative flex flex-col items-center justify-center py-2.5 transition-colors ${
                            isActive ? "text-[#1E3A8A]" : "text-slate-400 hover:text-slate-700"
                        }`}
                    >
                        <div className="relative">
                            <t.icon className={`w-5 h-5 ${isActive ? "stroke-[2.5]" : ""}`} />
                            {t.id === "inbox" && inboxCount > 0 && (
                                <span className="absolute -top-1.5 -right-2 inline-flex items-center justify-center min-w-[16px] h-4 px-1 bg-amber-500 text-[#0F172A] text-[9px] font-bold rounded-full">
                                    {inboxCount > 99 ? "99+" : inboxCount}
                                </span>
                            )}
                        </div>
                        <span className="text-[10px] mt-1 font-semibold">{t.label}</span>
                        {isActive && <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-1 bg-[#1E3A8A] rounded-b-full" />}
                    </button>
                );
            })}
        </nav>
    );
}
